import {
  getLayoutByEntityIdTypeApi,
  getLayoutByIdApi,
  LayoutResponseType,
  updateEntityName,
} from '@app-store'
import React, { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { LAYOUT_TYPE_NAMESPACE } from '../utils/constants'
import { AgentDeskParams } from '../types/params.types'
import TabLayout from '../components/tabs/TabLayout'
import { useAppDispatch } from '../utils/agent.store'

const TabWrapper = () => {
  const dispatch = useAppDispatch()
  const { entityId } = useParams<AgentDeskParams>()
  const [layout, setLayout] = useState<LayoutResponseType>()
  const { id } = useParams<AgentDeskParams>()
  const [searchParams] = useSearchParams()
  const layoutId = searchParams.get('layoutId')
  const fetchLayout = async () => {
    try {
      if (!layoutId) {
        const response = await getLayoutByEntityIdTypeApi({
          entityId: entityId ?? '',
          type: LAYOUT_TYPE_NAMESPACE.TABS_TYPE,
        })
        if (response) {
          const tabLayout = response?.filter(
            (layout: LayoutResponseType) => layout?.default_value
          )
          setLayout(tabLayout[0])
          dispatch(updateEntityName({ entityName: response[0]?.entity_name })) // meta data for bread crumb
        }
      } else {
        const res = await getLayoutByIdApi({
          entityId: entityId,
          layoutId: layoutId,
        })
        if (res) {
          setLayout(res?.data)
          dispatch(updateEntityName({ entityName: res?.data?.entity_name })) // meta data for bread crumb
        }
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fetchLayout()
  }, [entityId])

  return (
    layout &&
    id &&
    entityId && (
      <TabLayout
        layout={layout}
        recordId={id?.toString()}
        entityId={entityId}
      />
    )
  )
}

export default TabWrapper
